<div class="align-items-center d-flex flex-column gap-4 justify-content-center vh-100">
    <div>
        <svg xmlns="http://www.w3.org/2000/svg" width="124" height="125" viewBox="0 0 124 125" fill="none">
            <path
                d="M54.1771 86.9382C53.4989 86.9396 52.8271 86.807 52.2002 86.5481C51.5734 86.2892 51.0038 85.9091 50.5242 85.4295L28.6072 63.5074C28.1134 63.0311 27.7194 62.4613 27.4482 61.8311C27.177 61.2009 27.034 60.5231 27.0276 59.8371C27.0211 59.151 27.1514 58.4706 27.4107 57.8355C27.67 57.2003 28.0533 56.6232 28.538 56.1378C29.0228 55.6523 29.5994 55.2683 30.2342 55.008C30.8689 54.7478 31.5492 54.6166 32.2352 54.622C32.9212 54.6275 33.5993 54.7696 34.2298 55.0399C34.8604 55.3102 35.4308 55.7034 35.9077 56.1965L54.1719 74.4607L87.0577 41.5852C88.0265 40.6157 89.3408 40.0708 90.7113 40.0703C92.0819 40.0698 93.3965 40.6138 94.366 41.5826C95.3355 42.5514 95.8804 43.8656 95.8809 45.2362C95.8813 46.6068 95.3374 47.9214 94.3686 48.8909L57.8299 85.4295C57.3503 85.9091 56.7808 86.2892 56.1539 86.5481C55.5271 86.807 54.8553 86.9396 54.1771 86.9382Z"
                fill="#237C51" />
        </svg>
    </div>

    <div class="thanks-text-section col-sm-6 col-10 align-items-center d-flex flex-column gap-3 justify-content-center text-center">
        <div class="top-headings align-items-center d-flex flex-column gap-2 align-self-stretch">
            <h1>Thank You</h1>
            <h2>Your Data has been saved</h2>
        </div>
        <p>Please Verify your entries before printing or saving the receipt</p>
    </div>

    <div>
        <div
            class="action-buttons-wrapper align-content-center align-items-center d-flex flex-column flex-md-row gap-4 justify-content-end mt-auto pb-5">
            <button mat-stroked-button class="g-btn g-tertiary-btn">Print Reciept</button>
            <button mat-flat-button class="g-btn g-secondary-btn">Download Receipt</button>
            <button mat-flat-button class="g-btn g-primary-btn">Go to Homepage</button>
        </div>

    </div>
</div>